import React from 'react';
import { motion } from 'framer-motion';
export function DiagnosticoSection() {
  const problems = [{
    number: '01',
    title: 'Un abogado sin autoridad digital es solo un nombre en un directorio.',
    body: 'En el mercado legal de USA, la confianza lo es todo. El cliente no contrata al mejor abogado. Contrata al que más confianza le genera en los primeros 10 segundos de ver su perfil online.'
  }, {
    number: '02',
    title: 'Google Ads para abogados es el segmento más caro del mercado.',
    body: 'Sin una estrategia específica de palabras clave y landing pages, estás pagando $50-$200 por clic para atraer a personas que no califican para tus servicios.'
  }, {
    number: '03',
    title: 'No tienes un sistema de pre-calificación.',
    body: 'El 70% del tiempo de un abogado se va en consultas con personas que no pueden pagar o que no tienen un caso viable. Ese tiempo vale cientos de dólares por hora.'
  }];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-carbon relative border-t border-white/5" data-id="element-12">
      <div className="max-w-7xl mx-auto" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-14">
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-gold mb-6" data-id="element-15">
            Lo que nadie le dice a los abogados sobre el marketing digital.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-16">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-[#111] border border-white/5 rounded-2xl p-8 hover:border-gold/20 transition-colors duration-300 flex flex-col h-full" data-id="element-17">
              <span className="font-heading text-5xl font-bold text-white/10 mb-6 block" data-id="element-18">
                {problem.number}
              </span>
              <h3 className="font-heading text-xl sm:text-2xl font-semibold text-white mb-4" data-id="element-19">
                {problem.title}
              </h3>
              <p className="font-body text-gray-400 leading-relaxed flex-grow" data-id="element-20">
                {problem.body}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}